import CuttableProductPreview from "./components/CuttableProductPreview";

export default CuttableProductPreview
export { CuttableProductPreview }